export default __webpack_public_path__ + "static/media/julia.768adaf4.png";